import { InjectionKey, reactive, toRefs } from 'vue';

type IsFirstView = {
  mylist: boolean;
  survey: boolean;
};

interface State {
  userId: number | null;
  loading: boolean;
  isFirstLogin: boolean;
  isFirstView: IsFirstView;
  selectedChannel: 1 | 2;
  userAgent: string | null;
  userAgentData: NavigatorUAData | null;
  searchWorker: Worker | null;
  mylistWorker: Worker | null;
  programWorker: Worker | null;
}

export const useGlobalStore = () => {
  const state = reactive<State>({
    userId: null,
    loading: false,
    isFirstLogin: false,
    isFirstView: { mylist: false, survey: false },
    selectedChannel: 1,
    userAgent: null,
    userAgentData: null,
    searchWorker: null,
    mylistWorker: null,
    programWorker: null,
  });

  const setUserId = (userId: State['userId']) => {
    state.userId = userId;
  };

  const setIsFirstLogin = (isFirstLogin: State['isFirstLogin']) => {
    state.isFirstLogin = isFirstLogin;
    if (isFirstLogin) {
      setIsFirstViewMylist(true);
      setIsFirstViewSurvey(true);
    }
  };

  const setIsFirstViewMylist = (isFirstView: boolean) => {
    state.isFirstView.mylist = isFirstView;
  };

  const setIsFirstViewSurvey = (isFirstView: boolean) => {
    state.isFirstView.survey = isFirstView;
  };

  const setUserAgent = (userAgent: State['userAgent']) => {
    state.userAgent = userAgent;
  };

  const setUserAgentData = (userAgentData: State['userAgentData']) => {
    state.userAgentData = userAgentData;
  };

  const setSearchWorker = (searchWorker: Worker) => {
    state.searchWorker = searchWorker;
  };

  const setMylistWorker = (mylistWorker: Worker) => {
    state.mylistWorker = mylistWorker;
  };

  const setProgramWorker = (programWorker: Worker) => {
    state.programWorker = programWorker;
  };

  const startLoading = () => (state.loading = true);
  const stopLoading = () => (state.loading = false);

  return {
    ...toRefs(state),
    setUserId,
    setIsFirstLogin,
    setIsFirstViewMylist,
    setIsFirstViewSurvey,
    setUserAgent,
    setUserAgentData,
    startLoading,
    stopLoading,
    setSearchWorker,
    setMylistWorker,
    setProgramWorker,
  };
};

export type GlobalStoreType = ReturnType<typeof useGlobalStore>;
export const GlobalStoreKey: InjectionKey<GlobalStoreType> = Symbol('GlobalStore');
